<template>
  <div>
    <div class="row mb-3">
      <div class="col-md-6">
        <input
          v-model="searchQuery"
          type="text"
          class="form-control form-control-sm"
          placeholder="Search company..."
        />
      </div>
      <div class="col-md-6 text-right">
        <button class="e-btn e-btn-green e-text-white pr-3 mt-2 float-right" @click="openCreateModal">
          <font-awesome-icon icon="plus-square" style="width: 25px" />
          <small class="font-weight-bold text-uppercase">Add Inspector Company</small>
        </button>
      </div>
    </div>
    <!-- Pagination Controls -->
    <div class="row mt-3">
      <div class="col-md-6">
        <label>
          Show
          <select v-model="perPage" class="form-control form-control-sm d-inline-block w-auto ml-2">
            <option v-for="n in perPageOptions" :key="n" :value="n">{{ n }}</option>
          </select>
          entries
        </label>
      </div>
      <div class="col-md-6 text-right">
        <nav>
          <ul class="pagination pagination-sm justify-content-end mb-0">
            <li class="page-item" :class="{ disabled: currentPage === 1 }">
              <button class="page-link" @click="currentPage--" :disabled="currentPage === 1">
                Previous
              </button>
            </li>

            <li
              v-for="page in totalPages"
              :key="page"
              class="page-item"
              :class="{ active: currentPage === page }"
            >
              <button class="page-link" @click="currentPage = page">{{ page }}</button>
            </li>

            <li class="page-item" :class="{ disabled: currentPage === totalPages }">
              <button
                class="page-link"
                @click="currentPage++"
                :disabled="currentPage === totalPages"
              >
                Next
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <table class="table table-bordered table-sm table-hover">
          <thead>
          <tr>
            <th class="text-center align-middle text-uppercase font-weight-bold" scope="col">#</th>
            <th class="text-center align-middle text-uppercase font-weight-bold" scope="col">Company Name</th>
            <th class="text-center align-middle text-uppercase font-weight-bold" scope="col">Action</th>
          </tr>
          </thead>
          <tbody>
          <tr v-if="loading">
            <td colspan="7" class="text-center text-muted h6 p-3 text-uppercase font-weight-bold">
              Loading, Please wait.
            </td>
          </tr>
          <tr v-if="paginatedInspectorsCompanies.length === 0 && !loading">
            <td colspan="7" class="text-center text-muted h6 p-3 text-uppercase font-weight-bold">
              No results found
            </td>
          </tr>

          <tr v-for="(data, index) in paginatedInspectorsCompanies" :key="data.id">
            <td class="text-center align-middle">
              {{ (currentPage - 1) * perPage + index + 1 }}
            </td>
            <td class="text-center align-middle text-uppercase">{{ data.name }}</td>
            <td class="text-center">
              <div class="btn-group dropleft">
                <button class="mr-2 btn btn-sm btn-secondary force-white-all" data-toggle="dropdown" >
                  <font-awesome-icon icon="cogs" />
                </button>
                <div class="dropdown-menu dropdown-menu-right">
                  <button class="dropdown-item text-secondary font-weight-bolder" v-if="!data.deleted_at" @click="openEditModal(data)">
                    <font-awesome-icon icon="pen" /> &nbsp;Update
                  </button>
                  <button class="dropdown-item text-danger font-weight-bolder" v-if="!data.deleted_at" @click="openDeleteModal(data.id)">
                    <font-awesome-icon icon="trash" class="force-danger-all" />  &nbsp;Delete
                  </button>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>

      </div>
    </div>


    <div class="row mt-2">
      <div class="col-sm-12 text-right">
        <small class="text-muted">
          Showing
          <strong>{{ (currentPage - 1) * perPage + 1 }}</strong>
          to
          <strong>{{ Math.min(currentPage * perPage, filteredInspectorsCompanies.length) }}</strong>
          of
          <strong>{{ filteredInspectorsCompanies.length }}</strong>
          entries
        </small>
      </div>
    </div>

    <!-- Create Modal -->
    <div
      v-if="showCreateModal"
      class="modal fade show d-block"
      tabindex="-1"
      style="background: rgba(0,0,0,0.5);"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <form @submit.prevent="createInspectorCompany">
            <div class="modal-header">
              <h5 class="modal-title text-uppercase font-weight-bold">Add Inspector Company</h5>
              <button type="button" class="close" @click="cancelCreateModal">
                <span>&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label class="">Name <small class="text-danger font-weight-bold" style="font-style: italic;">(required)</small></label>
                <input v-model="form.name" class="form-control form-control-sm"/>
              </div>
            </div>
            <div class="modal-footer">
              <button type="submit" class="btn btn-primary btn-sm">Save</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Edit Modal -->
    <div
      v-if="showEditModal"
      class="modal fade show d-block"
      tabindex="-1"
      style="background: rgba(0,0,0,0.5);"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <form @submit.prevent="updateInspectorCompanies">
            <div class="modal-header">
              <h5 class="modal-title text-uppercase font-weight-bold">Edit Inspector Company</h5>
              <button type="button" class="close" @click="cancelUpdateModal">
                <span>&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>Company Name <small class="text-danger font-weight-bold" style="font-style: italic;">(required)</small></label>
                <input v-model="form.name" class="form-control form-control-sm" />
              </div>
            </div>
            <div class="modal-footer">
              <button type="submit" class="btn btn-primary btn-sm">Update</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Delete Modal -->
    <div
      v-if="showDeleteModal"
      class="modal fade show d-block"
      tabindex="-1"
      style="background: rgba(0,0,0,0.5);"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <form @submit.prevent="deleteInspectorCompanies">
            <div class="modal-header">
              <h5 class="modal-title text-uppercase font-weight-bold">Delete Company</h5>
              <button type="button" class="close" @click="cancelDeleteModal">
                <span>&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="text-center mb-3">
                <h5 class="text-uppercase font-weight-bold">Are you sure you want to delete this company?</h5>
              </div>
              <div class="form-group">
                <label class="font-weight-bold">Enter your password to confirm:</label>
                <input v-model="deletePassword" class="form-control form-control-sm" type="password"/>
                <small class="text-danger font-weight-bold" style="font-style: italic">Note: Once deleted, you can still restore this company.</small>
              </div>
            </div>
            <div class="modal-footer">
              <button type="submit" class="btn btn-primary btn-sm" v-if="deletePassword">Proceed</button>
              <button type="submit" class="btn btn-primary btn-sm" v-else disabled>Proceed</button>
            </div>
          </form>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { InspectorsService } from "@/services/InspectorsService";
import { InspectorsCompaniesService } from "@/services/InspectorsCompaniesService";
import Swal from 'sweetalert2';
import Table from "@/components/layouts/Table.vue";
import {AlertService} from "@/services/AlertService";

export default {
  name: "SettingCompany",
  components: {Table},

  data() {
    return {
      inspectors_companies: [],
      companies: [],
      loading: true,
      showCreateModal: false,
      showEditModal: false,
      showDeleteModal: false,
      editId: null,
      deleteId: null,
      deletePassword: null,
      form: {
        name: "",
      },
      currentPage: 1,
      perPage: 10,
      perPageOptions: [5, 10, 25, 50],
      searchQuery: "",
    };
  },
  computed: {
    filteredInspectorsCompanies() {
      if (!this.searchQuery) return this.inspectors_companies;
      const q = this.searchQuery.toLowerCase();
      return this.inspectors_companies.filter((i) => {
        const name = (i.name || '').toLowerCase();
        return name.includes(q);
      });
    },
    paginatedInspectorsCompanies() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.filteredInspectorsCompanies.slice(start, end);
    },
    totalPages() {
      const pages = Math.ceil(this.filteredInspectorsCompanies.length / this.perPage);
      return Math.max(1, pages);
    },
  },

  methods:{
    showToast(icon, title) {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon,
        title,
        showConfirmButton: false,
        timer: 2000,
      });
    },
    showAlert(icon, title, text = "", showCancel = false) {
      return Swal.fire({
        icon,
        title,
        text,
        showConfirmButton: true,
        confirmButtonColor: "#42b983",
        showCancelButton: showCancel,
        allowEscapeKey: false,
        allowOutsideClick: false,
        allowEnterKey: true,
        confirmButtonText: "OK",
      });
    },

    loadingModal() {
      Swal.fire({
        title: "Loading...",
        text: "Please wait",
        icon: "info",
        showCancelButton: false,
        showConfirmButton: false,
        allowEnterKey: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
    },

    async fetchInspectorsCompanies(id) {
      this.loading = true;
      try {
        const response = await InspectorsCompaniesService.getAll();
        this.inspectors_companies = response.data;
        if(!id){
          this.showToast("success", "Inspector companies loaded successfully!");
        }
      } catch (error) {
        console.error("Failed to load inspector companies", error);
        this.showToast("error", "Failed to load inspector companies!");
      } finally {
        this.loading = false;
      }
    },

    async createInspectorCompany() {
      try {
        if(!this.form.name){
          this.showAlert("error", "Company name is required!");
        }
        else if(this.form.name.length < 2){
          this.showAlert("error", "Company name must have at least 2 characters!");
        }
        else{
          const result = await Swal.fire({
            title: "Are you sure?",
            text: "Do you want to add this company?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#42b983",
            confirmButtonText: "Yes, please proceed!",
            cancelButtonText: "No, cancel!",
          });

          if (result.isConfirmed) {
            this.loadingModal();
            await InspectorsCompaniesService.create(this.form);
            this.showToast("success", "Company added!");
            this.showCreateModal = false;
            this.resetForm();
            this.fetchInspectorsCompanies('1');
          } else {
            this.showToast("info", "Creation cancelled");
          }
        }
      } catch {
        this.showToast("error", "Failed to create");
      }
    },

    async updateInspectorCompanies() {
      try {
        if(!this.form.name){
          this.showToast("error", "Company name is required!");
        }
        else if(this.form.name.length < 2){
          this.showToast("error", "Company name must have at least 2 characters!");
        }
        else{
          const result = await Swal.fire({
            title: "Are you sure?",
            text: "Do you want to update this company?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#42b983",
            confirmButtonText: "Yes, please proceed!",
            cancelButtonText: "No, cancel!",
          });

          if (result.isConfirmed) {
            this.loadingModal();
            await InspectorsCompaniesService.update(this.editId, this.form);
            this.showToast("success", "Company updated");
            this.showEditModal = false;
            this.resetForm();
            this.fetchInspectorsCompanies('1');
          }
        }
      } catch {
        this.showToast("error", "Failed to update");
      }
    },

    async deleteInspectorCompanies() {
      try {
        this.loadingModal();
        await InspectorsCompaniesService.deleteWithPassword(this.deleteId, this.deletePassword);
        this.showToast("success", "Company deleted!");
        this.fetchInspectorsCompanies(this.deleteId);

        this.showDeleteModal = false;
        this.deletePassword = '';
        this.deleteId = '';

        this.showAlert("success", "Company deleted successfully!");
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.showAlert("error", "Incorrect Password" ,"Please check if the password you entered is correct before submitting.");
        } else {
          AlertService.errorAlert('Failed to delete company', 'ERROR');
        }
      }
    },

    async restoreInspectorCompanies(id) {
      try {
        const result = await Swal.fire({
          title: "Are you sure?",
          text: "Do you want to restore this company?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#42b983",
          confirmButtonText: "Yes, please proceed!",
          cancelButtonText: "No, cancel!",
        });

        if (result.isConfirmed) {
          this.loadingModal();
          await InspectorsCompaniesService.restore(id);
          this.showToast("success", "Company restored!");
          this.fetchInspectorsCompanies(id);
        }
      } catch (error) {
        console.error("Failed to restore company", error);
        this.showToast("error", "Failed to restore company!");
      }
    },

    openCreateModal() {
      this.resetForm();
      this.showCreateModal = true;
    },

    cancelCreateModal(){
      this.showAlert('warning','Cancel Add Company', 'Are you sure you want to cancel? Any information you entered will not be saved.', true).then((result) => {
        if (result.isConfirmed) {
          this.showCreateModal = false;
          this.showAlert("error", "Add Company Cancelled!");
        }
      });
    },

    openEditModal(inspector) {
      this.form = {
        name: inspector.name,
      };
      this.editId = inspector.id;
      this.showEditModal = true;
    },

    cancelUpdateModal(){
      this.showAlert('warning','Cancel Update Company', 'Are you sure you want to cancel? Any changes you made will not be saved.', true).then((result) => {
        if (result.isConfirmed) {
          this.showEditModal = false;
          this.showAlert("error", "Update Company Cancelled!");
        }
      });
    },

    openDeleteModal(data) {
      this.showDeleteModal = true;
      this.deleteId = data;
      this.deletePassword = null;
    },

    cancelDeleteModal(){
      this.showAlert('warning','Cancel Delete Company', 'Are you sure you want to cancel? Any changes you made will not be saved.', true).then((result) => {
        if (result.isConfirmed) {
          this.showDeleteModal = false;
          this.deleteId = null;
          this.deletePassword = null;
          this.showAlert("error", "Delete Company Cancelled!");
        }
      });
    },

    resetForm() {
      this.form = {
        name: "",
      };
      this.editId = null;
    },
  },
  watch: {
    searchQuery() {
      this.currentPage = 1;
    },
    perPage() {
      this.currentPage = 1;
    },
    filteredInspectorsCompanies() {
      if (this.currentPage > this.totalPages) {
        this.currentPage = this.totalPages;
      }
    },
  },

  async created() {
    await this.fetchInspectorsCompanies();
  },
};
</script>

<style scoped>
.status-active {
  background-color: #10B981 !important;
}
.status-inactive {
  background-color: #EF4444;
}

.circle {
  display: inline-block;
  height: 10px;
  width: 10px;
  border-radius: 50px;
}
</style>
